import { Component, Injector, Input } from '@angular/core';
import { StoreCartComponent } from '../../store/store-cart/store-cart.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stripe-add-card',
  templateUrl: './stripe-add-card.component.html',
  styleUrls: ['./stripe-add-card.component.scss']
})
export class StripeAddCardComponent {
  storeCartCompo:any;
  forWebflow:boolean = false;

  constructor(private injector: Injector,public router: Router){
    if(router.url.includes('store/foursight-for-teams')){
      this.forWebflow = true;
      this.storeCartCompo = {
        loading: false,
        save_card: false,
        checkoutCard: () => {}
      }
    }else {
      this.storeCartCompo = this.injector.get(StoreCartComponent); 
    }
  }

  public close() {
    $('.add-card-modal').css('display', 'none');
  }

}
